export function menu () {
    return [
        {
            link: '/dashboard',
            icone: 'dashboard',
            nome: 'Dashboard'
        },
        {
            link: '/treinadores',
            icone: 'groups',
            nome: 'Treinadores'
        },
        {
            link: '/financeiro',
            icone: 'payments',
            nome: 'Financeiro'
        },
        {
            link: '/mensagens',
            icone: 'mail',
            nome: 'Mensagens'
        },
        {
            link: '/configuracao-ia',
            icone: 'smart_toy',
            nome: 'Configuração IA'
        },
        {
            link: '/rede-marketing',
            icone: 'hub',
            nome: 'Rede de Marketing'
        }
    ]
}